/* =========================================================
   DAWN ACCESSIBILITY FIXES
   Safe JS fixes for custom Dawn theme issues
   ========================================================= */

document.addEventListener('DOMContentLoaded', function () {
  fixBundleThumbnailButtons();
  fixMegaMenuImageLinks();
  fixKlaviyoFormNotice();
  fixLandmarks();
  fixReviewCarouselRoles();
  watchForDynamicChanges();
});

/* =========================================================
   1. IMAGE THUMBNAILS USED LIKE BUTTONS
   If a plain image acts like a control, wrap it like a button
   or add button semantics to its parent control.
   ========================================================= */
function fixBundleThumbnailButtons() {
  var thumbs = document.querySelectorAll('.bundle-thumbnail');

  thumbs.forEach(function (img, index) {
    var parentButton = img.closest('button, [role="button"], a');

    if (!parentButton) {
      return;
    }

    if (parentButton.tagName.toLowerCase() !== 'button' && !parentButton.getAttribute('role')) {
      parentButton.setAttribute('role', 'button');
      parentButton.setAttribute('tabindex', '0');
    }

    if (!parentButton.getAttribute('aria-label')) {
      var alt = img.getAttribute('alt') || ('Bundle thumbnail ' + (index + 1));
      parentButton.setAttribute('aria-label', 'Select ' + alt);
    }

    if (!parentButton.classList.contains('bundle-thumbnail-button')) {
      parentButton.classList.add('bundle-thumbnail-button');
    }

    if (parentButton.getAttribute('role') === 'button') {
      parentButton.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          parentButton.click();
        }
      });
    }
  });
}

/* =========================================================
   2. IMAGE ONLY LINKS IN MEGA MENU
   Add labels when link only contains an image
   ========================================================= */
function fixMegaMenuImageLinks() {
  var links = document.querySelectorAll('.mega-menu__link');

  links.forEach(function (link) {
    var text = link.textContent.replace(/\s+/g, ' ').trim();
    var img = link.querySelector('img');

    if (!text && img) {
      var alt = img.getAttribute('alt') || img.getAttribute('title') || 'Menu item';
      link.setAttribute('aria-label', alt);
    }
  });
}

/* =========================================================
   3. KLAVIYO FORM CONTEXT CHANGE NOTICE
   Adds a visible and screen-reader-friendly message.
   This helps only if the form is changing context unexpectedly.
   ========================================================= */
function fixKlaviyoFormNotice() {
  var forms = document.querySelectorAll('form[data-testid^="klaviyo-form"]');

  forms.forEach(function (form, index) {
    var noteId = 'klaviyo-context-note-' + index;

    if (!document.getElementById(noteId)) {
      var note = document.createElement('p');
      note.id = noteId;
      note.className = 'visually-hidden';
      note.textContent = 'This form may update or submit after you interact with the fields.';
      form.insertBefore(note, form.firstChild);
    }

    var controls = form.querySelectorAll('input, select, textarea, button');
    controls.forEach(function (control) {
      var existing = control.getAttribute('aria-describedby') || '';
      if (!existing.includes(noteId)) {
        control.setAttribute('aria-describedby', (existing + ' ' + noteId).trim());
      }
    });
  });
}

/* =========================================================
   4. LANDMARKS
   Makes sure important page areas are labeled
   ========================================================= */
function fixLandmarks() {
  var main = document.querySelector('#MainContent');
  if (main && main.tagName.toLowerCase() !== 'main') {
    main.setAttribute('role', 'main');
  }

  var newsletterWrapper = document.querySelector('.newsletter__wrapper');
  var newsletterHeading = document.querySelector('.newsletter__wrapper .h1.inline-richtext');

  if (newsletterWrapper && newsletterHeading) {
    if (!newsletterHeading.id) {
      newsletterHeading.id = 'NewsletterHeading';
    }

    if (!newsletterWrapper.hasAttribute('aria-labelledby')) {
      newsletterWrapper.setAttribute('aria-labelledby', newsletterHeading.id);
    }

    if (!newsletterWrapper.hasAttribute('role') && newsletterWrapper.tagName.toLowerCase() !== 'section') {
      newsletterWrapper.setAttribute('role', 'region');
    }
  }

  var scallop = document.querySelector('.scallop');
  if (scallop && scallop.getAttribute('role')) {
    scallop.removeAttribute('role');
  }
}

/* =========================================================
   5. BAD ROLES ON REVIEW SLIDES
   If a role is wrong on plain slides, remove it
   ========================================================= */
function fixReviewCarouselRoles() {
  var slides = document.querySelectorAll('#reviews-carousel-slide04, #reviews-carousel-clone07');

  slides.forEach(function (slide) {
    var role = slide.getAttribute('role');
    if (role && !['group', 'region', 'listitem'].includes(role)) {
      slide.removeAttribute('role');
    }

    if (!slide.getAttribute('aria-label')) {
      var text = slide.textContent.replace(/\s+/g, ' ').trim();
      if (text) {
        slide.setAttribute('aria-label', text);
      }
    }
  });
}

/* =========================================================
   6. WATCH FOR SHOPIFY OR APP CHANGES
   Re-run fixes if content loads later
   ========================================================= */
function watchForDynamicChanges() {
  var observer = new MutationObserver(function () {
    fixBundleThumbnailButtons();
    fixMegaMenuImageLinks();
    fixKlaviyoFormNotice();
    fixLandmarks();
    fixReviewCarouselRoles();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}